import { render, staticRenderFns } from "./WorkIconNavContacts.vue?vue&type=template&id=77710dc9"
import script from "./WorkIconNavContacts.vue?vue&type=script&lang=js"
export * from "./WorkIconNavContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports